module.exports = __webpack_public_path__ + "img/metal_ac@2x.02aee02e.png";